export default __webpack_public_path__ + "static/media/POTATO_STAGE_3.55ed168c.png";